import styled from 'styled-components';

import { Grid } from '@simplywallst/ui-core';

export const Tile = styled(Grid)`
  padding: 12px ${({ theme }) => theme.x2spacePx}px;
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  background-color: ${({ theme }) => theme.color.phantom};
`;
